import { render, staticRenderFns } from "./CsServicioDetalle.vue?vue&type=template&id=14f77fe1"
import script from "./CsServicioDetalle.vue?vue&type=script&lang=js"
export * from "./CsServicioDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports